import groupService from "./group.service";
import {
  CreateGroupMemberDto,
  GroupCreateDto,
  GroupDto,
  UpdateGroupDto,
} from "./group.types";
import { PublicMemberDto } from "../users/users.types";
import { UpdateGroupMemberDto } from "./organization.types";
import { createThunkWithError } from "../featureHelpers/errorParser";

export const createGroup = createThunkWithError<GroupDto, GroupCreateDto>(
  "groups/create",
  async (payload) => groupService.createGroup(payload)
);

// createGroupMember
export const createGroupMember = createThunkWithError<
  PublicMemberDto,
  CreateGroupMemberDto
>("groups/createGroupMember", ({ userId, groupId }) =>
  groupService.createGroupMember(userId, groupId)
);

// getGroup
export const getGroup = createThunkWithError<GroupDto, string>(
  "groups/getGroup",
  (groupId) => groupService.getGroup(groupId)
);

// getGroups
export const getGroups = createThunkWithError<GroupDto[], void>(
  "groups/getGroups",
  () => groupService.getGroups()
);

// updateGroup
export const updateGroup = createThunkWithError<GroupDto, UpdateGroupDto>(
  "groups/update",
  (data) => groupService.updateGroup(data)
);

// deleteGroup (returns the id after deletion)
export const deleteGroup = createThunkWithError<string, string>(
  "groups/delete",
  async (groupId) => {
    await groupService.deleteGroup(groupId);
    return groupId;
  }
);

// removeGroupMember (returns both ids)
export const removeGroupMember = createThunkWithError<
  { userId: string; groupId: string },
  { userId: string; groupId: string }
>("groups/removeGroupMember", async ({ userId, groupId }) => {
  await groupService.removeGroupMember(groupId, userId);
  return { userId, groupId };
});

// updateGroupMember
export const updateGroupMember = createThunkWithError<
  PublicMemberDto,
  UpdateGroupMemberDto
>("groups/updateGroupMember", (updateData) =>
  groupService.updateGroupMember(updateData)
);

// leaveGroup (returns both ids)
export const leaveGroup = createThunkWithError<
  { groupId: string; organizationId: string },
  { groupId: string; organizationId: string }
>("groups/leaveGroup", async ({ groupId, organizationId }) => {
  await groupService.leaveGroup(groupId);
  return { groupId, organizationId };
});
